import { RoleResponseDto } from '../dtos/role/role.response.dto';
import { Role } from '@domain/user/role';

export class RoleMapper {
  static toDomain(dto: RoleResponseDto): Role {
    return new Role(dto.id, dto.role);
  }

  static toDomainList(dtos: RoleResponseDto[]): Role[] {
    return dtos.map(RoleMapper.toDomain);
  }
}
